export type MembersOf<Union, Members extends Union> = Members;

export type AssertNoneMissing<Missing> = [Missing] extends [never]
  ? true
  : { missing: Missing };

export function unreachable(subject: string, value: never): never {
  throw new Error(`Unexpected ${subject} '${String(value)}'`);
}
